import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { createLoadingSelector } from '@hobs/utils/loading';
import WithRoles from '@hobs/hocs/WithRoles';
import _Order from '@hobs/containers/Order';
import {
  getOrder,
  clearOrder,
  downloadOrder,
  cancelOrder,
  sendOrder,
  updateOrder,
  deleteOrderAssignment,
  deleteOrder,
  canUpdate,
  updateAndSend,
  canRemoveServiceRequest
} from '@hobs/actions/orders';
import {
  uploadAttachments,
  setAttachments,
  deleteAttachment,
  clearAttachments
} from '@hobs/actions/attachment';
import { getCurrentParty } from '@hobs/actions/parties';

/**
 * Keeping this to be able to extend it in near future.
 */
class Order extends _Order {}

const oDataLoading = createLoadingSelector(['Orders/Get']);
const mapStateToProps = state => ({
  order: state.orders.order,
  isLoading: oDataLoading(state),
  attachments: state.attachment.attachments,
  currentParty: state.parties.currentParty
});

const mapDispatchToProps = {
  uploadAttachments,
  setAttachments,
  deleteAttachment,
  clearAttachments,
  getOrder,
  clearOrder,
  downloadOrder,
  cancelOrder,
  sendOrder,
  updateOrder,
  deleteOrderAssignment,
  deleteOrder,
  canUpdate,
  updateAndSend,
  canRemoveServiceRequest,
  getCurrentParty
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withRouter(WithRoles(Order))));
